export const fetchWithAuth = (url, body, contentType, callback, method) => {
    if (!method) method = 'POST';

    fetch(url, {
        method: method,
        body: body,
        headers: {
            'Content-Type': contentType,
            'Authorization': 'Bearer ' + localStorage.getItem("token")
        },
    }).then(function (res) {
        if (res.status === 401) {
            
        }
        else {
            res.json().then((result) => {
                callback(result);
            }).catch((err) => console.log(err));
        }
    });
}
